import React, {CSSProperties} from 'react';
import {concatenate} from "../../services/string";
import Dot from "./Dot";

enum Size {SMALL, LARGE}

const badgeSizeClasses: Record<Size, string> = {
    [Size.SMALL]: 'px-2.5 py-0.5 text-xs',
    [Size.LARGE]: 'px-3 py-0.5 text-sm',
}

const dotSizeClasses: Record<Size, string> = {
    [Size.SMALL]: '-ml-0.5 mr-1.5',
    [Size.LARGE]: '-ml-1 mr-1.5',
}

type Props = {
    size?: Size
    colour: CSSProperties['color']
    textColour?: CSSProperties['color']
    text: string
    title?: string
}

function Badge({colour, textColour, size, text, title}: Props) {

    const textStyle: CSSProperties = {
        color: textColour || colour,
        filter: (!textColour)? 'brightness(1.5)' : undefined
    }

    return (
        <span
            className={concatenate(badgeSizeClasses[size ?? Size.SMALL], 'inline-flex items-center rounded-md font-medium')}
            style={{backgroundColor: colour}}
            title={title}
        >
            {/* Dot */}
            <span className={concatenate(dotSizeClasses[size ?? Size.SMALL])}>
                <Dot colour={colour} filter={'brightness(1.5)'} />
            </span>

            {/* Text */}
            <span style={textStyle}>
                {text}
            </span>
        </span>
    );
}

Badge.sizes = Size

export default Badge;